<template>
  <section class="card">
    <header class="card-header">
      <div class="card-actions">
        <a href="#" class="card-action card-action-toggle" data-card-toggle></a>
      </div>

      <h2 class="card-title">{{$root.subTitle}}</h2>
    </header>
    <div class="card-body">
      <div class="mb-2">
        <router-link :to="{name:'/forms/values/create/:layoutId', params:{layoutId:layoutId}}" class="btn btn-primary btn-sm">Add
          <i class="fas fa-plus"></i>
        </router-link>
      </div>
      <table class="table table-bordered table-striped mb-none">
        <thead>
          <tr>
            <th>Value</th>
            <th>建立時間</th>
            <th class="actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in rows" :key="item.id">
            <td>{{item.value}}</td>
            <td>{{item.createTime|dateTime}}</td>
            <td class="actions">
              <router-link :to="{name:'/forms/values/edit/:id/:layoutId', params:{id:item.id, layoutId:layoutId}}" class="on-default edit-row">
                <i class="fas fa-pencil-alt"></i>
              </router-link>
              <a class="on-default remove-row" @click="remove(item.id, i)">
                <i class="fas fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import { formsValues } from "@/resource";

export default {
  data() {
    return {
      layoutId: this.$route.params.layoutId,
      rows: []
    };
  },
  mounted() {
    this.load().then(this.init);
  },
  methods: {
    init() {
      this.table = $(".table").dataTable({
        aoColumns: [
          ...new Array($("table th").length - 1),
          {
            bSortable: false
          }
        ]
      });
    },
    load() {
      return new Promise(resolve => {
        formsValues.get({ layoutId: this.layoutId }).then(a => {
          this.rows = a.body;
          resolve();
        });
      });
    },
    remove(id, i) {
      if (!confirm("確定要刪除嗎？")) return;
      formsValues.delete({ id }).then(a => {
        this.rows.splice(i, 1);
        this.table.fnDeleteRow(i);
      });
    }
  }
};
</script>
